// src/lib/seo.js
// Lightweight per-route metadata helper for this client-rendered SPA.
// Updates the document title and key meta/OG tags on navigation so each
// page reflects the right title/description in the browser and to crawlers
// that execute JavaScript.

const SITE_NAME = 'Down to Earth Guides';
const ORIGIN = 'https://downtoearthguides.com';

/**
 * Set or create a meta tag by attribute/value.
 * @param {string} attr - 'name' or 'property'
 * @param {string} key - the attribute value (e.g. 'description', 'og:title')
 * @param {string} content - the content to set
 */
function set_meta_tag(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Update page metadata for the current route.
 * @param {object} opts
 * @param {string} opts.title - Full <title> (without site suffix).
 * @param {string} opts.description - Meta description.
 * @param {string} [opts.path] - Route path for canonical/OG url (e.g. '/about').
 */
export function set_meta({ title, description, path = '' } = {}) {
  const full_title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  document.title = full_title;

  set_meta_tag('name', 'description', description);
  set_meta_tag('property', 'og:title', full_title);
  set_meta_tag('property', 'og:description', description);
  set_meta_tag('property', 'og:url', `${ORIGIN}${path}`);
  set_meta_tag('name', 'twitter:title', full_title);
  set_meta_tag('name', 'twitter:description', description);

  // Canonical link
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', `${ORIGIN}${path}`);
}
